import React from 'react';

function escapeHtml(text) {
    var entityMap = {
        "<": "&lt;",
        ">": "&gt;",
        '"': '&quot;',
        "'": '&#39;'
    };

    return String(text).replace(/[<>"']/g, function (s) {
        return entityMap[s];
    });
}

class Code extends React.Component {

    render() {
        const { highlighted, children, type, category } = this.props;
        const content = children;
        let parsed = '';
        const strReg = /("\S*\d*")/g,
            strReg2 = /([a-z]*=)/g,
            strReg3 = /("[a-z]"*)/g,
            specialReg = /\b(new|var|if|do|function|while|switch|for|foreach|in|continue|break)(?=[^\w])/g,
            specialJsGlobReg = /\b(document|window|Array|String|Object|Number|\$)(?=[^\w])/g,
            specialJsReg = /\b(getElementsBy(TagName|ClassName|Name)|getElementById|typeof|instanceof)(?=[^\w])/g,
            specialMethReg = /\b(indexOf|match|replace|toString|length)(?=[^\w])/g,
            specialPhpReg = /\b(define|echo|print_r|var_dump)(?=[^\w])/g;

        if (highlighted) {
            if (category === 'android') {
                if (type === 'code') {
                    parsed = content.replace(strReg,
                        ((matched) => {
                            return '<span class="c_str">' + escapeHtml(matched) + '</span>';
                        }));

                    parsed = parsed.replace(/\b(if|this)(?=[^\w])/g,
                        ((matched) => {
                            return '<span class="c_keyword">' + escapeHtml(matched) + '</span>';
                        }));
                }
                if (type === 'tag') {
                    parsed = content.replace(/(\<[\S]*)|("\S*\d*")|(\s\S*=)|(\/>)/g, (matched) => {
                        if (matched.match(/(\<[\S]*)/) || matched.match(/(\/>)/)) {
                            return '<span class="c_tag">' + escapeHtml(matched) + '</span>';
                        } else if (matched.match(/(\s\S*=)/)) {
                            return '<span class="c_attr">' + escapeHtml(matched) + '</span>';
                        }
                        return '<span class="c_str">' + escapeHtml(matched) + '</span>';
                    });
                }
            } else if (category === 'ios') {
                parsed = content.replace(strReg,
                    ((matched) => {
                        return '<span class="c_str">' + escapeHtml(matched) + '</span>';
                    }));
                parsed = parsed.replace(/\b(self|let|super|override|fileprivate|var|import|func|nil|_|NSLayoutConstraint|NotificationCenter|AlanButton)(?=[^\w])/g,
                    ((matched) => {
                        if (['NSLayoutConstraint', 'NotificationCenter', 'AlanButton'].indexOf(matched) >= 0) {
                            return '<span class="c_type">' + escapeHtml(matched) + '</span>';
                        }
                        return '<span class="c_keyword">' + escapeHtml(matched) + '</span>';
                    }));
            } else if (category === 'web') {
                if (type === 'tag') {
                    parsed = content.replace(/(\<[\S]*)|("\S*\d*")|(\s\S*=)|(\/>)|(>)/g, (matched) => {
                        if (matched.match(/(\<[\S]*)/) || matched.match(/(\/>)/) || matched.match(/(>)/)) {
                            return '<span class="c_tag">' + escapeHtml(matched) + '</span>';
                        } else if (matched.match(/(\s\S*=)/)) {
                            return '<span class="c_attr">' + escapeHtml(matched) + '</span>';
                        }
                        return '<span class="c_str">' + escapeHtml(matched) + '</span>';
                    });
                }
            }

        }

        return (
            <pre className={`code ${highlighted && 'highlighted'} ${category}`}>
                {parsed ? <span dangerouslySetInnerHTML={{ __html: parsed }} /> : content}
            </pre>
        );

    }
}

export default Code;

